interface BreakpointQueries {
  min?: string
  max?: string
}

interface Breakpoints {
  xl: BreakpointQueries
  lg: BreakpointQueries
  md: BreakpointQueries
  sm: BreakpointQueries
}
export const breakpoints: Breakpoints = {
  xl: { max: 'max-width: 1920px', min: 'min-width: 1601px' },
  lg: { max: 'max-width: 1600px', min: 'min-width: 993px' },
  md: { max: 'max-width: 992px', min: 'min-width: 481px' },
  sm: { max: 'max-width: 480px' },
} as const

export const getBreakPoint = (variant: keyof Breakpoints, version: keyof BreakpointQueries = 'max') => {
  if (variant) {
    return breakpoints[variant][version]
  }
}
